<ws-ace-card [header]="(userSetup) ? 'Additional Application Permissions' : 'Application Permissions'">
    <ng-container card-body>
        @for (permission of assignedPermissions | sortBy: 'sequence'; track permission) {
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center">
                    @if (editMode && userHasGlobalRole(permission)) {
                        <ws-select style="width: 100px; display: inline-block;"
                                   [(ngModel)]="permission.roleID"
                                   [options]="availablePermissionRights(permission.screenTypeID)"
                                   labelProperty="rights"
                                   valueProperty="roleID">
                        </ws-select>
                    }
                    @if (!editMode || !userHasGlobalRole(permission)) {
                        <span style="width: 100px; display: inline-block;"
                              class="application-permission-label">
                            {{ getPermissionLabel(permission.roleID) }}
                        </span>
                    }
                    <span [ngStyle]="{'margin-left': ((editMode && userHasGlobalRole(permission)) ? '14px':'inherit')}">
                        {{ permission.screenType }}
                    </span>
                </div>
                @if (editMode && userHasGlobalRole(permission)) {
                    <button class="ace-btn has-icon btn-primary btn-danger"
                            (click)="deletePermission(permission)">
                        <i class="fa fa-trash"></i>
                    </button>
                }
            </div>
        }
        @if (editMode) {
            <div style="margin-top: 10px;">
                @if (!(permissionToAdd || assignedPermissions.length === uniqueScreenTypes.length)) {
                    <button type="button" class="ace-btn btn-sm btn-primary"
                            (click)="selectPermissionToAdd()">
                        Add Application Permission
                    </button>
                }
                @if (permissionToAdd) {
                    <div class="d-flex align-items-center mt-2">
                        <ws-select style="width: 100px; display: inline-block;"
                                   [(ngModel)]="permissionToAdd.permission"
                                   [options]="screenTypePermissions"
                                   labelProperty="rights"
                                   [returnEntireOption]="true"
                                   [disabled]="!permissionToAdd.screenTypeID">
                        </ws-select>
                        <ws-select style="width: auto; display: inline-block;"
                                   (ngModelChange)="screenTypeSelected($event)"
                                   [ngModel]="permissionToAdd.screenTypeID"
                                   [options]="uniqueScreenTypes | sortBy:'screenType' | filter: usablePermission"
                                   labelProperty="screenType"
                                   valueProperty="screenTypeID">
                        </ws-select>
                        <button class="ace-btn has-icon btn-primary btn-success m-0 ms-2"
                                style="margin-left: 10px;"
                                type="button"
                                (click)="addPermission()"
                                [disabled]="!permissionToAdd.permission">
                            <i class="fa fa-save"></i>
                        </button>
                        <button class="ace-btn has-icon btn-primary btn-danger m-1"
                                type="button"
                                (click)="cancelAddPermission()">
                            <i class="fa fa-close"></i>
                        </button>
                    </div>
                }
            </div>
        }
    </ng-container>
</ws-ace-card>

